import type { TLandingPageInitialState } from "@/types/bottombar.types";
import { writable } from "svelte/store";

const initialState: TLandingPageInitialState = {
  showHardNudge: false,
  isInstallNudgeShown: false,
};

const { subscribe, update } = writable(initialState);

const updateState = (obj: typeof initialState) => {
  update((oldState) => ({ ...oldState, ...obj }));
};

export default {
  subscribe,
  updateState,
};
